export const hasAnyPermission = (user, permissionsList) => {
  if (!user || !Array.isArray(user.permissions) || !Array.isArray(permissionsList)) {
    return false;
  }
  return permissionsList.some((permission) => user.permissions.includes(permission));
};
